import styled from "styled-components";

const TemplatesStyled = styled.div`
  display: grid;
  flex-wrap: wrap;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  grid-row-gap: 25px;
  grid-column-gap: 25px;
`;
const TemplateStyled: any = styled.div`
  border-radius: 3px;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  transition: border-color 300ms cubic-bezier(0, 0.78, 0.58, 1);
  min-width: 226px;
  max-width: 300px;
  flex: 1 1 226px;
color:#1890ff;
position: relative;
/* ::before, */
::after {
  
  /* background:red; */
    /* z-index: -1; */
    /* margin: -5%; */
    box-shadow: inset 0 0 0 2px;
    ${({ loading }: any) =>
    loading
      ? "animation: clipMe 8s linear infinite;content: '';"
      : ""}
    
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  ::before {
    animation-delay: -4s;
  }

  :hover {
    border-color: #1890ff;
  }
  > div:nth-child(2) {
    position: relative;
    padding: 10px 20px;
    background: whitesmoke;
    border-top: 1px solid #e5e5e5;

    h4 {
      margin-bottom: 4px;
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 200px;
    }
    > div {
      display: block !important;
      color: #6e6e6e;
      font-size: 12px;
    }
  }
  .App {
    min-height: 0;
  }
  img {
    width: 100%;
  }
  > div {
    display: flex;

    div:first-child {
      h4:first-letter {
        text-transform: uppercase;
      }
      flex: 1;
      display: flex;
    }
    button:first-child {
    }
  }

  > div:nth-child(2) > div:nth-child(2) {
    opacity: 0;
    transform: translate(13px);
    transition: transform 300ms ease-in-out,
      opacity 300ms cubic-bezier(0, 0.78, 0.58, 1) 100ms;
    position: absolute;
    background: whitesmoke;
    right: 11px;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    display: flex !important;
  }
  ${({ loading }: any) =>
    loading
      ? "> div:nth-child(2) > div:nth-child(2) {opacity: 1;transform: translate(0);}"
      : ""}
  :hover {
    > div:nth-child(2) > div:nth-child(2) {
      opacity: 1;
      transform: translate(0);
    }
  }
  > div:nth-child(2) {
    button {
      border: none;
      background: transparent;
      padding: 5px 10px;
      position: relative;
      color: #1890ff;
      cursor: pointer;
      outline: none;

      :hover {
        i {
          transform: scale(1.5);
        }
      }
      :after {
        content: " ";
        position: absolute;
        width: 1px;
        top: 7px;
        bottom: 7px;
        background: #cccccc;
        right: 0;
      }
      :last-child:after {
        display: none;
      }
    }
  }
`;

const BlankTemplateStyled = styled.div`
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  /* height: 557px; */
  flex-direction: column;
  border: 1px dashed #000;
  div {
    margin-top: 12px;
    font-size: 14px;
  }
`;

const PaginationWrapper = styled.div`
  text-align: center;
  margin: 40px 0 0;
  position: sticky;
  bottom: 0;
  background: white;
  padding: 20px 0;
  box-shadow: 0px -4px 7px -5px #c4c4c4;
`;

const PreviewTemplateWrapper = styled.div`
  height: 237px;
  display: block !important;
  overflow: hidden;
  position: relative;
  padding: 9px;
  background: whitesmoke;
  img{
    box-shadow:1px 1px 5px #c4c4c4
  }
`;

export {
  TemplatesStyled,
  TemplateStyled,
  BlankTemplateStyled,
  PaginationWrapper,
  PreviewTemplateWrapper
};
